import styled, { css } from 'styled-components'

export type DividerProps = {
  marginTop?: string
  marginBottom?: string
  height?: string
  verticalHeight?: string
  leak?: string
  vertical?: boolean
}

const DividerNew = styled.div<DividerProps>`
  ${({
    theme,
    marginTop = '16px',
    marginBottom = '16px',
    height = '1px',
    leak = '0px',
    vertical = false,
    verticalHeight
  }) => css`
    background-color: ${theme.ds.colors.neutral100};
    width: ${vertical ? '1px' : `calc(100% + (${leak} * 2))`};
    margin-left: -${leak};
    margin-top: ${vertical ? 0 : marginTop};
    margin-bottom: ${vertical ? 0 : marginBottom};
    height: ${verticalHeight ? verticalHeight : vertical ? '32px' : height};
  `}
`

export default DividerNew
